module.exports = __webpack_public_path__ + "img/Afterpay sticker black on mint no bordersmall.f9a86b9c.png";